import { render, staticRenderFns } from "./InfoWithIcon.vue?vue&type=template&id=86babcd4&"
import script from "./InfoWithIcon.vue?vue&type=script&lang=ts&"
export * from "./InfoWithIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports